import { jsxs as g, jsx as r, Fragment as R } from "react/jsx-runtime";
import { useRef as y, useEffect as N, useCallback as k } from "react";
import "../../utils/normalizeForCollation/index.js";
import "../../hooks/useInputSystem/system/constants.js";
import "../../hooks/useInputSystem/key/constants.js";
import "../../hooks/useInputSystem/provider/context.js";
import { usePrefersReducedMotion as v } from "../../hooks/usePrefersReducedMotion/index.js";
import { aX as w, aY as A, aZ as C, a_ as T, a$ as q, b0 as B, b1 as F } from "../../vendor-Dd6qj6gJ.js";
import "../../theme/spacing.js";
import { omitStyleRenderProps as K } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as z } from "../BaseIcon/index.js";
import '../../assets/index56.css';const D = "_tabs_ij16r_1", M = "_tabList_ij16r_14", E = "_tab_ij16r_1", V = "_label_ij16r_55", X = "_underline_ij16r_59", Y = "_selectionIndicator_ij16r_69", Z = "_tabPanels_ij16r_83", G = "_tabPanel_ij16r_83", H = "_icon_ij16r_116", n = {
  tabs: D,
  tabList: M,
  tab: E,
  label: V,
  underline: X,
  selectionIndicator: Y,
  tabPanels: Z,
  tabPanel: G,
  icon: H
};
function L(a) {
  return "href" in a;
}
function J(a) {
  return a.length > 0 && L(a[0]);
}
function ie(a) {
  const { items: i, selectedKey: d, defaultSelectedKey: b, onSelectionChange: u, ...P } = a, l = y(null), j = v(), m = J(i), S = (e) => {
    if (!m)
      return {};
    if (!L(e))
      return {};
    const { target: t } = e, o = (() => {
      if (t !== "_blank")
        return e.rel;
      const s = new Set(
        (e.rel ?? "").split(/\s+/).map((c) => c.trim()).filter(Boolean)
      );
      return s.add("noopener"), s.add("noreferrer"), [...s].join(" ");
    })();
    return {
      download: e.download,
      href: e.href,
      hrefLang: e.hrefLang,
      ping: e.ping,
      referrerPolicy: e.referrerPolicy,
      rel: o,
      target: t
    };
  }, _ = d ?? b, p = (e, t) => {
    if (!e)
      return;
    const o = t === void 0 ? e.querySelector('[role="tab"][data-selected]') : Array.from(e.querySelectorAll('[role="tab"]')).find(
      (I) => I.getAttribute("data-key") === String(t)
    );
    if (!o)
      return;
    const s = e.getBoundingClientRect(), c = o.getBoundingClientRect(), h = c.left - s.left, $ = c.right - s.right;
    let f = e.scrollLeft;
    if (h < 0)
      f += h;
    else if ($ > 0)
      f += $;
    else
      return;
    e.scrollTo({
      behavior: j ? "auto" : "smooth",
      left: f
    });
  };
  N(() => {
    requestAnimationFrame(() => p(l.current, _));
  }, [_]);
  const x = k(
    (e) => {
      u?.(e), requestAnimationFrame(() => p(l.current, e));
    },
    [u]
  );
  return i.length === 0 ? null : /* @__PURE__ */ g(
    w,
    {
      ...K(P),
      className: n.tabs,
      orientation: "horizontal",
      keyboardActivation: "automatic",
      selectedKey: d,
      defaultSelectedKey: b,
      onSelectionChange: x,
      children: [
        /* @__PURE__ */ r(
          A,
          {
            ref: l,
            "aria-label": a["aria-label"],
            items: i,
            className: n.tabList,
            children: (e) => {
              const t = e;
              return /* @__PURE__ */ r(
                C,
                {
                  id: t.id,
                  isDisabled: t.isDisabled,
                  className: n.tab,
                  ...S(t),
                  children: T(e.label, (o) => /* @__PURE__ */ g(R, { children: [
                    e.startIcon && /* @__PURE__ */ r(z, { icon: e.startIcon, size: "sm", className: n.icon }),
                    /* @__PURE__ */ r("span", { className: n.label, children: o }),
                    /* @__PURE__ */ r(F, { className: n.selectionIndicator })
                  ] }))
                }
              );
            }
          }
        ),
        /* @__PURE__ */ r("div", { className: n.underline }),
        !m && /* @__PURE__ */ r(q, { items: i, className: n.tabPanels, children: (e) => /* @__PURE__ */ r(B, { id: e.id, className: n.tabPanel, children: e.content }) })
      ]
    }
  );
}
export {
  ie as Tabs
};
